import React, { useState, useEffect } from 'react';
import {
  MessageCircle,
  Users,
  CreditCard,
  Clock,
  Handshake
} from 'lucide-react';
import baseURL from '../url';
import Navbar from '../Navbar/Navbar';
import './FinanciacionComponent.css';

const Financiacion = () => {
  const [bannerImages, setBannerImages] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleWhatsAppClick = () => {
    const phoneNumber = "5491134567890";
    const message = "Hola! Me interesa conocer las opciones de financiación para comprar un auto.";
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleFinanciamientoClick = () => {
    const target = document.querySelector('.benefits-section');
    if (target) {
      window.scrollTo({ top: target.offsetTop - 60, behavior: 'smooth' });
    }
  };

  const cargarBanners = () => {
    fetch(`${baseURL}/bannersGet.php`)
      .then(res => res.json())
      .then(data => {
        if (data.banner && Array.isArray(data.banner)) {
          const filtered = data.banner
            .filter(b => b.financiacion === 1)
            .map(b => b.imagen);
          setBannerImages(filtered);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Error al cargar banners:', err);
        setLoading(false);
      });
  };

  useEffect(() => {
    cargarBanners();
  }, []);

  return (
    <div className="financiacion-page">
      <Navbar />

      {/* HERO SECTION */}
      <br />
      <br />
      <br />
      <section className="hero-section">
        <div className="container">
          <div className="hero-content" style={{ marginTop: '-20px' }}>
            <div className="hero-text">
              <h1>FINANCIA TU AUTO DE MANERA SIMPLE Y SEGURA</h1>
              <p className="subtitle">
                Con Filoni, tu próximo auto está más cerca. Ofrecemos planes de financiamiento claros, flexibles y pensados para que tengas tu vehículo sin complicaciones.
              </p>

              <div className="cta-buttons">
                <button className="btn-primary" onClick={handleFinanciamientoClick}>
                  <Users className="btn-icon" />
                  Conocer Financiamiento
                </button>
                <button className="btn-secondary" onClick={handleWhatsAppClick}>
                  <MessageCircle className="btn-icon" />
                  WhatsApp
                </button>
              </div>
            </div>

            <div className="hero-image" >
              {!loading && bannerImages.length > 0 ? (
                <img
                  src={bannerImages[0]}
                  alt="Financiación Filoni"
                  className="hero-img"
                />
              ) : (
                <img
                  src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=600&q=80"
                  alt="Financiación de autos"
                  className="hero-img"
                />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* BENEFICIOS SECTION */}
      <section className="benefits-section">
        <div className="container" style={{ paddingTop: '2rem' }}>
          <h2 className="section-title">TENES QUE ELEGIRNOS</h2>
          <p className="section-subtitle">
            En Filoni, hacemos que financiar tu auto sea un proceso rápido, transparente y adaptado a vos.
          </p>

          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon-wrapper">
                <Clock className="benefit-icon" />
              </div>
              <h3>Financiamiento fácil y rápido</h3>
              <p>Gestionamos todo el proceso por vos, de manera ágil y sin complicaciones.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon-wrapper">
                <Handshake className="benefit-icon" />
              </div>
              <h3>Asesoramiento personalizado y gratuito</h3>
              <p>Te ayudamos a conseguir el crédito más conveniente según tu caso, con la tasa más baja.</p>
            </div>

            <div className="benefit-card">
              <div className="benefit-icon-wrapper">
                <CreditCard className="benefit-icon" />
              </div>
              <h3>Amplia gama de créditos y formas de pago</h3>
              <p>Recibimos casi todas las formas de pago y gestionamos créditos de diversas entidades bancarias, tanto cuota fija como UVA.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="final-cta">
        <div className="container" style={{ paddingTop: '2rem' }}>
          <h2 className="section-title">FINANCIA TU PROXIMO AUTO</h2>
          <p className="final-subtitle">
            En Filoni te ayudamos a dar el paso hacia tu nuevo vehículo con planes de financiamiento simples, claros y a tu medida.
            Accedé a tu auto ideal sin complicaciones, con asesoramiento personalizado y la confianza de siempre.
          </p>

          <div className="final-buttons">
            <button className="btn-secondary large" onClick={handleWhatsAppClick}>
              <MessageCircle className="btn-icon" />
              Hablar por WhatsApp
            </button>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Financiacion;
